export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home'),
    meta: {
      auth: true,
      title: 'Home',
    },
  },
  {
    path: '/habbits',
    name: 'habbits',
    component: () => import('@/views/Habbits'),
    meta: {
      auth: true,
      title: 'Habbits',
    },
  },
  {
    path: '/perf',
    name: 'performance',
    component: () => import('@/views/Performance'),
    meta: {
      auth: true,
      title: 'Performance',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/utility/Login'),
    meta: {
      auth: false,
      title: 'Login',
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/utility/Logout'),
    meta: {
      auth: true,
      title: 'Logout',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/utility/Register'),
    meta: {
      auth: false,
      title: 'Register',
    },
  },
  {
    path: '/forgotten/username',
    name: 'forgotten-username',
    component: () => import('@/views/utility/ForgottenUsername'),
    meta: {
      auth: false,
      title: 'Forgotten Username',
    },
  },
  {
    path: '/forgotten/password',
    name: 'forgotten-password',
    component: () => import('@/views/utility/ForgottenPassword'),
    meta: {
      auth: false,
      title: 'Forgotten Password',
    },
  },
];
